export async function geocodeAddress(address) {
  const apiKey = 'AIzaSyAHz8thxxs3ahY5pjfayZ9N9S4ZL_CT-cU';
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === 'OK') {
      const location = data.results[0].geometry.location;
      return { latitude: location.lat, longitude: location.lng };
    } else {
      console.error('Geocoding failed:', data.status);
      return {};
    }
  } catch (error) {
    console.error('Geocoding fetch error:', error);
    return {};
  }
}